import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import { TimerProvider, GlobalTimerOverlay } from '../../context/TimerContext';
import FloraActionHub from '../FloraActionHub';
import PlanJobBanner from '../PlanJobBanner';
import CreditErrorDialog from '../CreditErrorDialog';

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center h-64 gap-3">
      <img src="/nico-transparent.svg" alt="Nico" className="w-12 h-12 nico-breathe" />
      <div className="w-8 h-8 border-3 border-teal-200 border-t-teal-400 rounded-full animate-spin" />
    </div>
  );
}

export default function Layout() {
  return (
    <TimerProvider>
      <div className="flex h-screen bg-warm-50 max-w-full overflow-hidden font-body">
        <Sidebar />
        <main className="flex-1 min-w-0 pb-24 md:pb-0 overflow-y-auto">
          <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </Suspense>
        </main>
        <GlobalTimerOverlay />
        <BottomNav />
        <FloraActionHub />
        <PlanJobBanner />
        <CreditErrorDialog />
      </div>
    </TimerProvider>
  );
}
